module.exports = moment;


//////////////////
// WEBPACK FOOTER
// external "moment"
// module id = 96
// module chunks = 0